import { render, staticRenderFns } from "./TypographyComponent.vue?vue&type=template&id=beddf3ba&"
import script from "./TypographyComponent.vue?vue&type=script&lang=js&"
export * from "./TypographyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports